import {
  branch,
  compose,
  renderNothing,
  withStateHandlers,
  withProps
} from 'recompose'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { withRouter, matchPath } from 'react-router'
import { createDigest } from 'src/actions/client'
import { getCurrentPath } from 'src/helpers/browser'
import { selectRouteKey } from 'src/store/selectors/routes'
import { selectHomeIsErrored } from 'src/store/selectors/home'
import { selectBuyerErrorModal } from 'src/store/selectors/buyerInfo'
import { PATH_HELPERS } from 'src/constants/navigation'

const AuthErrorContainer = compose(
  withRouter,
  withProps(() => ({
    routeKey: selectRouteKey()
  })),
  withStateHandlers(
    {
      email: '',
      complete: false
    },
    {
      setEmail: () => e => ({ email: e.target.value }),
      setComplete: () => () => ({ complete: true })
    }
  ),
  connect(
    state => ({
      authError: selectBuyerErrorModal(state) || selectHomeIsErrored(state)
    }),
    (dispatch, { email, setComplete }) => ({
      onSubmit: e => {
        e.preventDefault()

        const match = matchPath(getCurrentPath(), {
          path: PATH_HELPERS.report.matchPath
        })

        if (match && email) {
          const { clientId } = match.params

          dispatch(createDigest({ clientId, email }))
          setComplete()
        }
      }
    })
  ),
  branch(({ authError }) => !authError, renderNothing),
  injectIntl
)

export default AuthErrorContainer
